import React, { useState } from 'react';
import { Container } from '@mui/material';
import { useGames } from '../shared/hooks/useGames';
import { useStreamingProviders } from '../shared/hooks/useStreamingProvider';
import { useStreamingOffer } from '../shared/hooks/useStreamingOffer';
import ErrorSnackbar from '../shared/snackbar/ErrorSnackbar';
import { StyledPaper } from './GameFinder.styled';
import { StyledTypo } from '../overviewandfilter/styled/OverviewAndFilter.styled';
import Loader from '../shared/loader/Loader';
import GameFinderResult from './gamefinderResult/GameFinderResult';
import GameFinderFormControl from './formcontrol/GameFinderFormControl';

const GameSelection: React.FC = () => {
  const { games, loading: gamesLoading, error: gamesError } = useGames();
  const {
    providers,
    loading: spLoading,
    error: spError,
  } = useStreamingProviders();
  const {
    streamingOffer,
    loading: soLoading,
    error: soError,
  } = useStreamingOffer();
  const isLoading = gamesLoading || spLoading || soLoading;
  const hasError = gamesError || spError || soError;
  const [selectedTournament, setSelectedTournament] = useState<string | null>(
    null
  );
  const [selectedHomeTeam, setSelectedHomeTeam] = useState<string | null>(null);
  const [selectedAwayTeam, setSelectedAwayTeam] = useState<string | null>(null);

  const getProviderNameById = (id: string): string => {
    const provider = providers?.find((p) => p.id.toString() === id);
    return provider ? provider.name : '';
  };

  const filteredGames = games?.filter((game) => {
    return (
      (!selectedTournament || game.tournament_name === selectedTournament) &&
      (!selectedHomeTeam || game.team_home === selectedHomeTeam) &&
      (!selectedAwayTeam || game.team_away === selectedAwayTeam)
    );
  });

  const getProvidersForGame = (gameId: string, type: 'live' | 'highlights') => {
    if (!streamingOffer || streamingOffer.length === 0) return [];
    return streamingOffer
      .filter(
        (offer) => offer.game_id.toString() === gameId && offer[type] === 1
      )
      .map((offer) =>
        getProviderNameById(offer.streaming_package_id.toString())
      )
      .filter((name) => name);
  };
  const sortedTournaments = Array.from(
    new Set(games?.map((game) => game.tournament_name))
  ).sort((a, b) => a.localeCompare(b));
  if (hasError) {
    return <ErrorSnackbar customError="Error loading GameFinder" open />;
  }

  return (
    <Container>
      <StyledTypo
        variant="h4"
        align="left"
        fontWeight="bold"
        fontStyle="italic"
      >
        Game Finder
      </StyledTypo>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <StyledPaper>
            <GameFinderFormControl
              label="Competition"
              data={sortedTournaments}
              value={selectedTournament}
              setFunction={setSelectedTournament}
            />
            {selectedTournament && (
              <GameFinderFormControl
                label="Home Team"
                value={selectedHomeTeam}
                setFunction={setSelectedHomeTeam}
                data={Array.from(
                  new Set(
                    games
                      ?.filter(
                        (game) => game.tournament_name === selectedTournament
                      )
                      .map((game) => game.team_home)
                  )
                )}
              />
            )}

            {selectedHomeTeam && (
              <GameFinderFormControl
                label="Away Team"
                value={selectedAwayTeam}
                setFunction={setSelectedAwayTeam}
                data={Array.from(
                  new Set(
                    games
                      ?.filter(
                        (game) => game.tournament_name === selectedTournament
                      )
                      .map((game) => game.team_away)
                  )
                )}
              />
            )}
          </StyledPaper>

          {selectedAwayTeam && (
            <div>
              {filteredGames?.map((game) => {
                const liveProviders = getProvidersForGame(
                  game.id.toString(),
                  'live'
                );
                const highlightProviders = getProvidersForGame(
                  game.id.toString(),
                  'highlights'
                );

                return (
                  <GameFinderResult
                    game={game}
                    highlightProviders={highlightProviders}
                    liveProviders={liveProviders}
                  />
                );
              })}
            </div>
          )}
        </>
      )}
    </Container>
  );
};

export default GameSelection;
